import React, { useState } from 'react'
import SoftButton from './SoftButton'
import { Copy, FacebookLogo, InstagramLogo, PinterestLogo, ShareNetwork, TiktokLogo, X } from '@phosphor-icons/react'
import { toast } from 'react-toastify'
import { Toast } from '@components/ToastTemplates/Toast'
import Tooltip from './Tooltip'
import { sendGAEvent } from '@utils/analytics'

const ShareInSocialMedia = ({ product, className = '' }) => {
	const publicShareUrl = typeof window !== 'undefined' ? window.location.href : null;
	const [showSocialMediaIcons, setShowSocialMediaIcons] = useState(false)

	const handleShare = (type) => {
		// TO-DO: finalize product url if prop is passed
		const currentProductUrl = publicShareUrl;

		if (type === 'facebook') {
			window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentProductUrl)}`, '_blank')
		} else if (type === 'instagram' || type === 'tiktok') {
			const toastId = toast(<Toast type="success" title='Success!' message="URL copied. Paste and share the product url to everyone!" handleClose={() => toast.dismiss(toastId)} />)

			navigator.clipboard
				.writeText(publicShareUrl)
				.then(() => {
					if (type === 'instagram') {
						window.open(`instagram://create`, '_blank');

						// Fallback to Instagram website after a delay
						setTimeout(() => {
							window.open('https://www.instagram.com/', '_blank');
						}, 300);
					} else {
						window.open('https://www.tiktok.com/upload', '_blank');
					}
				})
		} else if (type === 'pinterest') {
			const mediaURL = "https://your-image-url.com/example.jpg" // TO-DO: replace with actual image URL
			const pinterestShareUrl = `https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(
				currentProductUrl
			)}&media=${encodeURIComponent(mediaURL)}&description=${encodeURIComponent(
				"Check this out!" // TO-DO: replace with actual product description
			)}`;
			window.open(pinterestShareUrl, '_blank')
		}

		sendGAEvent('product_shared', {
			queryName: type,
			niceName: product?.title,
		})
	}

	const handleCopy = () => {
		navigator.clipboard
			.writeText(publicShareUrl)
	}

	return (
		<React.Fragment>
			<div className={`relative ${className} ${showSocialMediaIcons && 'z-[55]'}`}>
				<div className="inline-flex gap-x-2">
					<SoftButton
						label={"Share"}
						onClick={() => setShowSocialMediaIcons(!showSocialMediaIcons)}
						icon={<ShareNetwork size={20} weight="fill" />}
						iconGap="gap-x-1"
						iconPosition="start"
						ariaLabel={"Share"}
					/>
				</div>

				<div onClick={() => setShowSocialMediaIcons(false)} className={`fixed left-0 top-0 size-full bg-black bg-opacity-25 ${showSocialMediaIcons ? "block" : "hidden"}`} />

				<div
					className={`fixed md:absolute bg-white p-4 mr-0 md:mr-2 right-0 min-w-[360px] bottom-0 md:bottom-[unset] sm:drop-shadow-top-sm ${showSocialMediaIcons ? "block" : "hidden"
						} shadow-lg space-y-4`}
				>
					<div className="flex flex-nowrap justify-between items-center text-black">
						<span className="flex-1 text-[20px]">Spread the Word, Fam!</span>
						<X
							className="cursor-pointer text-black"
							size={24}
							weight="light"
							onClick={() => {
								setShowSocialMediaIcons(false);
							}}
							aria-label='close'
						/>
					</div>

					<p>
						Found something you love? Let your friends know! Pick a platform
						below to share the excitement.
					</p>

					<div className='flex gap-4 py-2'>
						<FacebookLogo size={40} weight='fill' className='cursor-pointer' aria-label='share-facebook' onClick={() => handleShare('facebook')} />
						<InstagramLogo size={40} weight='fill' className='cursor-pointer' aria-label='share-instagram' onClick={() => handleShare('instagram')} />
						<TiktokLogo size={40} weight='fill' className='cursor-pointer' aria-label='share-tiktok' onClick={() => handleShare('tiktok')} />
						<PinterestLogo size={40} weight='fill' className='cursor-pointer' aria-label='share-pinterest' onClick={() => handleShare('pinterest')} />
					</div>

					<div className='w-full'>
						<p>Or copy link:</p>
						<div role='button' className='w-full inline-flex gap-x-3 border border-gray-400 p-3' aria-label='copy-link' onClick={() => handleCopy()}>
							<div className='border-0 flex-1 select-none'>{publicShareUrl}</div>
							<Tooltip
								text={'Copy'} textOnClick={'Copied'}
								offsetBubble='-top-5'
								offsetBubblePointer="top-3"
							>
								<Copy className='cursor-pointer' size={24} weight='light' />
							</Tooltip>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
}

export default ShareInSocialMedia